import * as React from 'react';
import { useSelector } from 'react-redux';

import { Notificator } from '../../components/Notificator';
import { IApplicationState } from '../../types/redux';

export const NotificatorContainer: React.FC = () => {
  const { isOpen, content, duration } = useSelector((state: IApplicationState) => state.notification);

  return <Notificator isOpen={isOpen} content={content} duration={duration} />;
};

NotificatorContainer.displayName = 'NotificatorContainer';
